/* Home page image content slide Js Logic */
document.addEventListener("DOMContentLoaded", function () {
    let imageCarousel = document.querySelector(".image-carousel");
    if(!imageCarousel) return;
    let flkty = new Flickity(imageCarousel);
    let contentSlides = document.querySelectorAll(".content-slide");
    let contentArea = document.querySelector(".content-area");

    function updateActiveSlide(index) {
        contentSlides.forEach(function (slide) {
            slide.classList.remove("active");
        });

        if (contentSlides[index]) {
            contentSlides[index].classList.add("active");
            contentArea.style.height = contentSlides[index].offsetHeight + "px";
        }
    }

    updateActiveSlide(flkty.selectedIndex);

    flkty.on("change", function (index) {
        updateActiveSlide(index);
    });

    window.addEventListener("resize", function () {
        updateActiveSlide(flkty.selectedIndex);
    });
});

// Career Apply Page Dropdown Customization
(function () {

    if (!window.location.href.includes('pages/career-apply-now')) return;

    const params = new URLSearchParams(window.location.search);

    const positionAppliedFor = params.get('PositionAppliedFor');
    const locationParam = "ahmedabad";

    if (!positionAppliedFor && !locationParam) return;

    function normalizeText(str) {
        if (!str) return "";
        return str
            .toLowerCase()
            .replace(/-/g, " ")
            .replace(/\//g, " ")
            .replace(/\s+/g, " ")
            .trim();
    }

    const expectedPosition = normalizeText(positionAppliedFor);
    const expectedLocation = normalizeText(locationParam);



    let attempts = 0;
    const maxAttempts = 40; 
    let positionDone = false;
    let locationDone = false; 

    const formWatcher = setInterval(() => {

        attempts++;

        const formEmbed = document.querySelector('shopify-forms-embed#app-embed');

        if (!formEmbed || !formEmbed.shadowRoot) {
            if (attempts >= maxAttempts) clearInterval(formWatcher);
            return;
        }

        const shadowRoot = formEmbed.shadowRoot;

        if (!shadowRoot.querySelector("#custom-style")) {

            const style = document.createElement("style");
            style.id = "custom-style";
            style.textContent = `
                [aria-controls="custom#position_applying_for_1_1_1-selector-dropdown"] div,
                [aria-controls="custom#location-selector-dropdown"] div{
                    display:none;
                }
            `;

            shadowRoot.appendChild(style);

            if (typeof formCss !== "undefined") {
                const link = document.createElement("link");
                link.id = "style-link";
                link.rel = "stylesheet";
                link.href = formCss;
                shadowRoot.appendChild(link);
            }
        }


        const positionDropdown = shadowRoot.querySelector(
            '[aria-controls="custom#position_applying_for_1_1_1-selector-dropdown"]'
        );

        const locationDropdown = shadowRoot.querySelector(
            '[aria-controls="custom#location-selector-dropdown"]'
        );

        if (positionDropdown && expectedPosition && !positionDone) {

            positionDropdown.click();

            setTimeout(() => {
                let optionsWrapper = positionDropdown.querySelector('div');
                if(!optionsWrapper) return;
                const options = optionsWrapper.querySelectorAll('[role="option"]');

                options.forEach(option => {

                    const optionText = normalizeText(option.innerText);

                    if (
                        optionText.includes(expectedPosition) ||
                        expectedPosition.includes(optionText)
                    ) {

                        option.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                        option.click();
                        option.dispatchEvent(new Event('input', { bubbles: true }));
                        option.dispatchEvent(new Event('change', { bubbles: true }));

                        positionDone = true;
                    }
                });

            }, 1000);
        }        

        if (locationDropdown && expectedLocation && !locationDone) {

            locationDropdown.click();

            setTimeout(() => {

                let optionsWrapper = locationDropdown.querySelector('div');
                if(!optionsWrapper) return;
                const options = optionsWrapper.querySelectorAll('[role="option"]');

                options.forEach(option => {

                    const optionText = normalizeText(option.innerText);

                    if (
                        optionText.includes(expectedLocation) ||
                        expectedLocation.includes(optionText)
                    ) {
                        option.click();
                        locationDone = true;
                    }
                });

            }, 1000);
        }

        if (positionDone || locationDone || attempts >= maxAttempts) {

            clearInterval(formWatcher);

            setTimeout(() => {
                const style = shadowRoot.querySelector("#custom-style");
                const link = shadowRoot.querySelector("#style-link");
                if (style) style.remove();
                if (link) link.remove();
            }, 1500);
        }

    }, 500);

})();

// Get free estimation page
{
    let page = window.location.href;

    if (page.includes('pages/get-free-estimation') || page.includes('get-a-quote')) {
        const intervalId = setInterval(() => {
            let formEmbed = document.querySelector('form-embed#app-embed');
            if (!formEmbed) return;
            clearInterval(intervalId);

            let styleContainer = document.createElement('link');
            styleContainer.id = "style-link"
            styleContainer.rel = "stylesheet";
            styleContainer.href = formCss;
            styleContainer.type = "text/css";
            
            let shadowRootElem = formEmbed.shadowRoot;
            shadowRootElem.appendChild(styleContainer);
        }, 2000);
        
        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    }
}



// contact page
{
    let page = window.location.href;

    if (page.includes('pages/contact') || document.body.classList.contains('template-suffix-contact-new')) {
        const intervalId = setInterval(() => {
            let formEmbed = document.querySelector('shopify-forms-embed#app-embed');
            if (!formEmbed) return;
            clearInterval(intervalId);

            let styleContainer = document.createElement('link');
            styleContainer.id = "style-link"
            styleContainer.rel = "stylesheet";
            styleContainer.href = formCss;
            styleContainer.href = contactformCss;
            styleContainer.type = "text/css";
            
            let shadowRootElem = formEmbed.shadowRoot;
            shadowRootElem.appendChild(styleContainer);
        }, 500);
        
        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    }
}
// custom faq section accordin open js 
{
    document.addEventListener("DOMContentLoaded", function () {
        const triggers = document.querySelectorAll(".accordion__trigger");

        triggers.forEach(trigger => {
            const item = trigger.closest(".accordion__item");
            const content = trigger.nextElementSibling;

            trigger.addEventListener("click", () => {
                const isOpen = item.classList.contains("is-open");

                // Close all accordions
                document.querySelectorAll(".accordion__item").forEach(el => {
                    el.classList.remove("is-open");
                    el.querySelector(".accordion__trigger").setAttribute("aria-expanded", "false");
                    el.querySelector(".accordion__content").setAttribute("hidden", true);
                });

                // Toggle clicked accordion
                if (!isOpen) {
                    item.classList.add("is-open");
                    trigger.setAttribute("aria-expanded", "true");
                    content.removeAttribute("hidden");
                }
            });
        });
    });


}

// Open Shopify Inbox chat window on .js-chat-open click
(function() {
    document.addEventListener("DOMContentLoaded", function() {
        const chatOpenButtons = document.querySelectorAll(".js-chat-open");

        chatOpenButtons.forEach(button => {
            button.addEventListener("click", function(e) {
                
                // If it's a link with a hash or empty href, prevent default
                if (button.getAttribute("href") === "#" || !button.getAttribute("href")) {
                    e.preventDefault();
                }

                const chatWatcher = setInterval(() => {
                    // Shopify Inbox usually injects inbox-online-store-chat or shopify-chat
                    const chatContainer = document.querySelector("inbox-online-store-chat") || document.querySelector("shopify-chat");
                    
                    if (chatContainer && chatContainer.shadowRoot) {
                        const chatToggle = chatContainer.shadowRoot.querySelector(".chat-toggle");
                        const checkOpen = chatContainer.shadowRoot.querySelector(".chat-app--is-open");
                        if(checkOpen){
                            clearInterval(chatWatcher);
                            return;
                        }

                        
                        if (chatToggle) {
                            chatToggle.click();
                            clearInterval(chatWatcher);
                            return;
                        }
                    }

                    // Fallback: check if direct element exists
                    const directToggle = document.querySelector(".chat-toggle");
                    if (directToggle) {
                        directToggle.click();
                        clearInterval(chatWatcher);
                    }
                }, 100);
            });
        });
    });
})();
